module.exports = __webpack_public_path__ + "img/1-4.ae842328.png";